import { defineStore } from 'pinia';
import { FullPartner, PartnerType } from '../partner-types';
import { TaskTree } from '../../project/project-types';

export const usePartnerStore = defineStore({
  id: 'partner',

  state: () => ({
    currentType: '' as PartnerType,
    partner: {} as FullPartner,
    taskTree: [] as TaskTree[],
  }),

  getters: {},

  actions: {
    setType(type: PartnerType): void {
      this.currentType = type;
    },
    setPartner(partner: FullPartner): void {
      this.currentType = partner.type;
      this.partner = partner;
    },
    setTaskTree(taskTree: TaskTree[]): void {
      this.taskTree = taskTree;
    },
  },
});
